let isDev = false;

try {
  const url = location.origin;
  if (
    url.includes('192.168') ||
    url.includes('localhost') ||
    url.includes('127.0.0.1') ||
    url.includes('testwww')
  ) {
    isDev = true;
  }
} catch {

}

const apiPath = '/bpis';
// const mdApiPath = isDev ? 'http://kafka.crm.lan/scada/collect' : 'https://crm.etescape.com:12343/maidian/scada/collect';
const userCenterUrl = isDev ?'https://testwww.rlc525.com': 'https://www.rlcproltd.net';
const userCenterLoginUrl = `${userCenterUrl}/uc/login`;
const mdApiPath= '/maidian/scada/collect';
const apsApi = '/aps'
const serviceApi = '/cms';

export {
  apiPath,
  mdApiPath,
  apsApi,
  isDev,
  serviceApi,
  userCenterUrl,
  userCenterLoginUrl,
}
